import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../../text/messages';
import { CLIENT_DOCTYPES, PERMISSIONS, DOCUMENT_NAMES } from '../../components/document/types';
import Document from './../../components/document';

export class DocTableHeader extends React.Component {
    render() {
        return (
            <div className="col-xs-12 manage-documents-header no-select">
                <div className="col-sm-5 col-xs-8 column">
                    <span className="ellipsis">
                        <FormattedMessage id={'document'} defaultMessage={'Document'} />
                    </span>
                </div>
                <div className="col-xs-3 hidden-xs column">
                    <span className="ellipsis">
                        <FormattedMessage id={'owner'} defaultMessage={'Owner'} />
                    </span>
                </div>
                <div className="col-xs-2 hidden-xs column">
                    <span className="ellipsis">
                        <FormattedMessage id={'uploadDate'} defaultMessage={'Upload Date'} />
                    </span>
                </div>
                <div className="col-sm-2 col-xs-4 column text-right">
                    <span className="ellipsis">
                        <FormattedMessage id={'actions'} defaultMessage={'Actions'} />
                    </span>
                </div>
            </div>
        );
    }
}

export function renderDocument(onOpen, display) {
    return (
        <div className="table-row">
            <div className="row">
                <div className="col-xs-12">
                    <div className="col-xs-8 column-name ellipsis">
                        <FormattedMessage {...messages.upload} /> {display}
                    </div>
                    <div className="col-xs-4 text-right">
                        <button className="btn btn-sm btn-success" type="button" onClick={onOpen}>
                            <FormattedMessage {...messages.upload} />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export function requiredDocumentControls(docTypes, onUploaded = undefined) {
    return (
        <div>
            <div className="manage-documents">
                <div className="row section">
                    <div className="col-xs-12">
                        {docTypes.map((type, i) => (
                            <div className={`color-${i % 2 === 0 ? '1' : '2'}`} key={i}>
                                <Document
                                    id={`${type}${i}`}
                                    upload={{
                                        button: onOpen => renderDocument(onOpen, DOCUMENT_NAMES[type]),
                                        limit: type === CLIENT_DOCTYPES.OTHER ? 10 : 1,
                                        permissions: PERMISSIONS.DEFAULT,
                                        onUploaded
                                    }}
                                    docType={type}
                                    displayName={DOCUMENT_NAMES[type]}
                                    view={{ showHeader: false }}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Document id={'all-documents'} docType={''} />
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/pages/documents/common.jsx